<template>
  <div class="my-licence">
    <div class="account-card">
      <div class="account-card-header">
        <h4 class="account-card-title">我的委托处置</h4>
      </div>
      <div class="page-manage page-manage-evaluation-config">
        <customize-form
          :form-config="formConfig"
          @on-query="onQuery"
          @on-reset="onReset"
        ></customize-form>
        <el-button type="primary" style="margin-bottom:10px" @click="onAdd"
          >新增</el-button
        >
        <customize-table
          :table-config="tableConfig"
          @size-change="onSizeChange"
          @current-change="onCurrentChange"
          :currentPage.sync="params.pageIndex"
        >
          <template v-slot:title="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span
                  class="cell-link"
                  @click="
                    if (scope.row.statusCode == '0') {
                      onPayment(scope.row)
                    } else {
                      onCheck(scope.row)
                    }
                  "
                  >{{ scope.row.title }}</span
                >
              </template>
            </el-table-column>
          </template>
          <template v-slot:serveScope="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span @click="onLink(scope.row)">{{
                  scope.row.serveScope == 1
                    ? '竞价服务'
                    : scope.row.serveScope == 2
                    ? '全流程服务'
                    : ''
                }}</span>
              </template>
            </el-table-column>
          </template>

          <template v-slot:assetClass="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span>{{
                  scope.row.assetClass == 1
                    ? '废旧物资'
                    : scope.row.assetClass == 2
                    ? '闲置物资'
                    : ''
                }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:scheduleCode="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span>{{ getClassCodefun(scope.row.scheduleCode) }}</span>
              </template>
            </el-table-column>
          </template>
          <template v-slot:operations="{ column }">
            <el-table-column v-bind="column">
              <template v-slot="scope">
                <span
                  @click="onPayment(scope.row)"
                  class="cellbutton text"
                  v-if="scope.row.statusCode == '0'"
                  >修改</span
                >
                <span
                  @click="onDelete(scope.row)"
                  class="cellbutton text"
                  v-if="scope.row.statusCode == '0'"
                  >删除</span
                >
                <span
                  @click="onCheck(scope.row)"
                  class="cellbutton text"
                  v-if="scope.row.statusCode != '0'"
                  >查看</span
                >
                <span
                  @click="onWithdraw(scope.row)"
                  class="cellbutton text"
                  v-if="
                    scope.row.noticeCount == 0 && scope.row.statusCode != '0'
                  "
                  >撤回</span
                >
              </template>
            </el-table-column>
          </template>
        </customize-table>
      </div>
    </div>
  </div>
</template>
<script>
import { daterange, openNewPage } from '@/utils/constantime'
export default {
  data() {
    return {
      removeV: 1,
      pageNum: 1,
      pageSize: 10,
      params: {
        pageIndex: 1,
        pageSize: 10
      },
      formConfig: {
        configs: {},
        operations: [
          {
            label: '查询',
            handler: 'on-query',
            type: 'primary'
          },
          {
            label: '清空',
            handler: 'on-reset',
            type: 'default'
          }
        ]
      },
      queryTabs: [
        {
          label: 1,
          name: '待确认'
        },
        {
          label: 2,
          name: '已确认'
        }
      ],
      activeName: 1,
      //未发布
      preorganizationFormConfig: {
        code: {
          tag: 'input',
          label: '委托编号'
        },
        title: {
          tag: 'input',
          label: '委托标题'
        },

        assetClass: {
          label: '物资类型',
          tag: 'select',
          options: [
            { value: 1, label: '废旧物资' },
            { value: 2, label: '闲置物资' }
          ]
        },
        scheduleCode: {
          label: '进度',
          tag: 'select',
          options: []
        },
        serveScope: {
          tag: 'select',
          label: '服务范围',
          options: [
            { value: 1, label: '竞价服务' },
            { value: 2, label: '全流程服务' }
          ]
        },
        submitTime: {
          ...daterange,
          label: '提交日期'
        }
      },

      // 默认表格配置
      tableConfig: {
        isPagination: true,
        columns: [],
        data: [],
        total: 0
      },
      // 未发布
      preorganizationTableColumns: [
        {
          label: '序号',
          type: 'index',
          width: '50px',
          align: 'center'
        },
        {
          prop: 'code',
          label: ' 委托编号',
          // width: '100px',
          'show-overflow-tooltip': true
        },
        {
          slot: 'title',
          prop: 'title',
          label: '委托标题',
          'show-overflow-tooltip': true
        },
        {
          slot: 'assetClass',
          prop: 'assetClass',
          'show-overflow-tooltip': true,
          label: '物资类型',
          align: 'center'
        },

        {
          slot: 'serveScope',
          prop: 'serveScope',
          label: '服务范围',
          align: 'center',
          width: '150px'
        },
        {
          prop: 'submitTime',
          label: '提交日期',
          align: 'center'
        },
        {
          prop: 'scheduleCode',
          slot: 'scheduleCode',
          label: '状态',
          align: 'center',
          width: '150px'
        },
        {
          slot: 'operations',
          prop: 'operations',
          label: '操作',
          width: '100px',
          align: 'center',
          fixed: 'right'
        }
      ]
    }
  },
  watch: {},
  created() {
    this.planListTodo()
    this.getClassCode()
  },
  methods: {
    onCurrentChange(val) {
      this.params = {
        ...this.params,
        pageIndex: val,
        pageSize: 10
      }
      this.planListTodo()
    },
    onSizeChange(val) {
      this.params = {
        pageIndex: 1,
        pageSize: val
      }
      this.planListTodo()
    },
    onCheckBidFile(o) {
      let query = {
        id: o.id,
        pagetype: 2
      }
      openNewPage('CompileMaterialcheck', query)
    },

    async planListTodo() {
      this.formConfig.configs = this.preorganizationFormConfig
      this.tableConfig.columns = this.preorganizationTableColumns
      let obj = {
        ...this.params
      }
      let data = await this.$api.materialdisposal.getPlanlist(obj)
      this.tableConfig.data = data.data
      this.tableConfig.total = data.total
    },
    async getClassCode() {
      let params = {
        classCode: 'PLAN_PROGRESS'
      }
      let data = await this.$api.common.getClassCode(params)
      console.log(data)
      this.preorganizationFormConfig.scheduleCode.options = data.data.map(
        item => {
          return {
            value: item.codeCode,
            label: item.codeName
          }
        }
      )
    },
    getClassCodefun(val) {
      let name = ''
      this.preorganizationFormConfig.scheduleCode.options.map(item => {
        if (item.value == val) {
          name = item.label
        }
      })
      return name
    },
    onQuery(val) {
      this.params = {
        ...val,
        pageIndex: this.pageNum,
        pageSize: this.pageSize,
        submitTimeEnd:
          val.submitTime && val.submitTime.length != 0
            ? val.submitTime[1]
            : null,
        submitTimeStart:
          val.submitTime && val.submitTime.length != 0
            ? val.submitTime[0]
            : null,
        submitTime: null
      }
      this.planListTodo()
    },
    onReset() {
      this.params = {
        pageIndex: this.pageNum,
        pageSize: this.pageSize
      }
      this.planListTodo()
    },
    onLink() {
      this.$openNewPage('AgreementDetail')
    },
    //修改
    onPayment(o) {
      let query = {
        id: o.id,
        pageType: 'modify'
      }
      this.$router.push({ name: 'EntrustedDisposalDetail', query })

      // openNewPage('CompileMaterialupdata', query)
    },
    onAdd() {
      this.$router.push({ name: 'EntrustedDisposalDetail' })
    },
    onDelete(row) {
      console.log(row)
      this.$confirm('确定删除此条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.planDelete(row)
        })
        .catch(() => {})
    },
    async planDelete(row) {
      let params = {
        id: row.id
      }
      let data = await this.$api.materialdisposal.planDelete(params)
      if (data) {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
        this.planListTodo()
      }
    },
    onWithdraw(row) {
      this.$confirm('确定撤回此条数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.planPut(row)
        })
        .catch(() => {})
    },
    async planPut(row) {
      let params = {
        id: row.id
      }
      let data = await this.$api.materialdisposal.planPut(params)
      if (data) {
        this.$message({
          type: 'success',
          message: '撤回成功!'
        })
        this.planListTodo()
      }
    },
    onCheck(row) {
      let query = {
        id: row.id,
        pageType: 'check'
      }
      this.$openNewPage('EntrustedDisposalDetail', query)
    }
  }
}
</script>
<style lang="less" scoped>
.text {
  margin-right: 8px;
}
</style>
